require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-giusi-boni.json") })
        }
      }, "path---en-interviste-giusi-boni");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-giusi-boni!./.cache/json/en-interviste-giusi-boni.json
// module id = 583
// module chunks = 231608221292675